import React from 'react'

import { cva, type VariantProps } from 'class-variance-authority'

import { Icons } from '@/components/atoms/Icons/Icons.tsx'
import { cn } from '@/lib/utils.ts'

const notificationSoundToggleVariants = cva(
  'inline-flex h-[33px] w-[36px] shrink-0 items-center justify-center rounded-[6px] p-2',
  {
    variants: {
      state: {
        enabled: 'border border-[#046c4e] bg-[#0e9f6e]',
        muted:
          'border-b border-b-gray-600 bg-gradient-to-b from-[rgba(58,72,98,0.94)] via-[rgba(17,25,40,0.78)] via-[5.208%] to-[#010203]',
      },
    },
    defaultVariants: {
      state: 'enabled',
    },
  }
)

const iconVariants = cva('size-6', {
  variants: {
    state: {
      enabled: 'text-white',
      muted: 'text-[#9CA3AF]',
    },
  },
  defaultVariants: {
    state: 'enabled',
  },
})

export interface NotificationSoundToggleProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof notificationSoundToggleVariants> {}

export const NotificationSoundToggle = React.forwardRef<HTMLButtonElement, NotificationSoundToggleProps>(
  ({ className, state, ...props }, ref) => (
    <button type="button" className={cn(notificationSoundToggleVariants({ state, className }))} ref={ref} {...props}>
      {state === 'enabled' ? (
        <Icons.volumeUp className={cn(iconVariants({ state }))} />
      ) : (
        <Icons.noSound className={cn(iconVariants({ state }))} />
      )}
    </button>
  )
)
